<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增平台服务器
      </el-button>
      <div class="former">
        <select2
          v-model="form.PlatformID"
          url="platform"
          labelName="PlatformName"
          placeholder="请选择平台"
          no-data-text="无平台"
        ></select2>&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * (pager.page)).toString().length * 12)"
      ></el-table-column>
      <el-table-column prop="Platform.PlatformName" label="平台名称"></el-table-column>
      <el-table-column label="远程工具" align="center">
        <el-table-column prop="Manner.Name" label="远程方式"></el-table-column>
        <el-table-column prop="RemoteAccount" label="远程账号"></el-table-column>
        <el-table-column prop="RemotePassword" label="远程密码"></el-table-column>
      </el-table-column>
      <el-table-column prop="CommProtocol.Name" label="通讯协议"></el-table-column>
      <el-table-column prop="ServerUsername" label="服务器用户名"></el-table-column>
      <el-table-column prop="ServerPassword" label="服务器密码"></el-table-column>
      <el-table-column prop="IP" label="IP地址" width="150"></el-table-column>
      <el-table-column prop="Port" label="端口号" width="80"></el-table-column>
      <el-table-column width="100" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" @click.stop="onEditItem(scope.row)" title="编辑">
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button type="danger" @click.stop="onDeleteItem(scope.row)" title="删除">
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>

    <item-form v-model="item" :visible.sync="itemVisible" @form:saved="getItemList" />
  </el-card>
</template>

<script>
import ItemForm from './index--form.vue';

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        PlatformID: '',
      },
      item: this.getEmptyItem(),
      itemVisible: false,
    };
  },
  mounted() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get('platformserver', {
          params: {
            where: this.form,
            with: ['Platform','CommProtocol', 'ServerType', 'Manner'],
            ...this.pager,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, 'size', 'page', 'total');
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onEditItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm('确定要删除吗？', '提示')
        .then(() => this.$axios.delete(`platformserver/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success('成功删除');
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    getEmptyItem() {
      return {
      };
    },
  },
};
</script>
